// extracted by mini-css-extract-plugin
module.exports = {"headlineRegular":"m1headline_headlineRegular__riKbN","headlineLarge":"m1headline_headlineLarge__NzjY6","subHeadline":"m1headline_subHeadline__yvnVO"};